export default __webpack_public_path__ + "static/media/SacredTrust.261b6986.png";